import * as React from "react";
import {
  AddButton,
  AdvancedSearchTable,
  CustomBreadcrumbProps,
  PageBase,
} from "../../components";
import { useCommonHooks } from "../../hooks";
import { ETLCodes } from "../../locales";
import { ERoutes } from "../../AppRouter";
import { IDataTableColumn } from "nsitools-react";
import { MeetingGridDto } from "../../api";
import { Icon, Switch } from "@blueprintjs/core";
import styled from "styled-components";
import { useAuth } from "../../contexts";
import { getDateHour } from "../../utils";
import { AllUsersSwitch } from "../../components/AllUsersSwitch.tsx";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  justify-content: space-around;
  align-items: center;
`;

export interface IHomePageProps {}

export const HomePage: React.FunctionComponent<IHomePageProps> = () => {
  const { apis, t, router } = useCommonHooks();

  const meetingApi = apis.meetings;
  const [showEveryone, setShowEveryone] = React.useState(false);
  const { user } = useAuth();
  const search = React.useCallback(
    (sObj: any) => {
      if (showEveryone) return meetingApi.baseSearch(sObj);
      return meetingApi.baseSearchByUser(sObj, user.employeeId);
    },
    [meetingApi, showEveryone, user.employeeId]
  );
  const breadCrumbs = React.useMemo<CustomBreadcrumbProps[]>(
    () => [{ text: t(ETLCodes.MeetingList) }],
    [t]
  );

  const onAddClick = React.useCallback(
    () => router.goToEditPage(ERoutes.meeting, -1, "details", "edit"),
    [router]
  );

  const onRowClick = React.useCallback(
    (item: MeetingGridDto) =>
      router.goToEditPage(ERoutes.meeting, item.id, "details", "edit"),
    [router]
  );

  const columns = React.useMemo<IDataTableColumn<MeetingGridDto>[]>(
    () => [
      {
        fieldName: "bookingDate",
        header: () => t(ETLCodes.Date),
      },
      {
        fieldName: "startHour",
        header: () => t(ETLCodes.StartHour),
        render: (row) => (
          <div>{row.startHour ? getDateHour(row.startHour) : ""}</div>
        ),
      },
      {
        fieldName: "duration",
        header: () => t(ETLCodes.Duration),
      },
      {
        fieldName: "site",
        header: () => t(ETLCodes.Site),
      },
      {
        fieldName: "room",
        header: () => t(ETLCodes.Room),
      },
      {
        fieldName: "employee",
        header: () => t(ETLCodes.For),
      },

      {
        fieldName: "meetingType",
        header: () => t(ETLCodes.MeetingType),
      },
      {
        fieldName: "isInterpreterRequired",
        header: () => t(ETLCodes.InterpreterRequired),
        render: (value) => (
          <Icon icon={value.isInterpreterRequired ? "tick" : "cross"} />
        ),
      },
      {
        fieldName: "isUrgent",
        header: () => t(ETLCodes.IsUrgent),
        render: (value) => <Icon icon={value.isUrgent ? "tick" : "cross"} />,
      },
    ],
    [t]
  );

  return (
    <PageBase breadCrumbs={breadCrumbs}>
      <AdvancedSearchTable
        //onRowClick={onRowClick}
        searchFunction={search}
        columns={columns}
        sortKeys={{ bookingDate: "DESC" }}
        rightElement={
          <Container>
            <AllUsersSwitch
              value={showEveryone}
              onChange={() => setShowEveryone(!showEveryone)}
            />
            <AddButton onClick={onAddClick} />
          </Container>
        }
      />
    </PageBase>
  );
};
